<style
  lang="less"
  scoped>
  .what-need-panel {
    border: 1px dashed #999;
    margin: 20px 30px;
    padding-top: 28px;
    position: relative;

    .what_tit {
      width: 282px;
      height: 33px;
      text-align: center;
      background-color: #fff;
      line-height: 33px;
      font-size: 25px;
      color: #333;
      font-weight: bold;
      position: absolute;
      top: -15px;
      left: 50%;
      margin-left: -141px;
    }

    .what-need-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0 20px;
      padding-top: 55px;
      padding-bottom: 30px;
      li {
        font-size: 16px;
        margin-left: 20px;
        margin-right: 20px;
        box-sizing: border-box;
        margin-top: 10px;
        display: flex;
        p {
          height: 45px;
          width: 180px;
          overflow: hidden;
          margin-top: -2px;
        }
        span {
          display: inline-block;
          width: 30px;
          height: 30px;
          background-color: #0077db;
          color: #fff;
          font-size: 18px;
          line-height: 30px;
          text-align: center;
          margin-right: 5px;
        }
      }
    }
  }

  .ps_1 {
    .ps_con {
      height: 367px;
      margin: 3px;
      box-sizing: border-box;
      background: url("//v3.cdn.qiyewan.com/gs_tu.png") no-repeat;
      background-size: cover;
      h3 {
        color: #fdf70b;
        font-size: 61px;
        padding-top: 95px;
        padding-left: 66px;
        margin-bottom: 5px;
      }
      h4 {
        color: #fff;
        font-size: 36px;
        padding-left: 71px;
      }
      p {
        color: #b9e7ff;
        font-size: 27px;
        padding-left: 70px;
        padding-top: 30px;
        letter-spacing: 2px;
      }
    }
  }

  .ps_2 {
    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
    }
    ul li {
      float: left;
      margin-top: 30px;
      width: 33%;
      text-align: center;
      box-sizing: border-box;
      p {
        font-size: 14px;
        color: #999;
      }
      h3 {
        font-size: 25px;
        color: #333;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 5px;
      }
    }
  }

  .ps_3 {
    background-color: #f1f2f8;
    margin: 3px;
    box-sizing: border-box;
    overflow: hidden;
    height: 430px;
    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
    }
    ul {
      margin: 40px 60px;
      li {
        float: left;
        margin-right: 20px;
        background: #fff;
        width: 234px;
        padding: 45px 25px 0;
        height: 265px;
        box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.3);
        h3 {
          color: #333;
          font-size: 22px;

        }
        p {
          color: #666;
          font-size: 16px;
          margin-top: 50px;
        }
      }
      li:nth-of-type(3) {
        margin-right: 0 !important;
        background: url("//v3.cdn.qiyewan.com/gszx.png") no-repeat right top #fff;
      }
      li:nth-of-type(1) {
        background: url("//v3.cdn.qiyewan.com/gsbg.png") no-repeat right top #fff;
      }
      li:nth-of-type(2) {
        background: url("//v3.cdn.qiyewan.com/gszc.png") no-repeat right top #fff;
      }
    }
  }

  .ps_4 {
    margin: 3px 3px 20px;
    box-sizing: border-box;
    overflow: hidden;

    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
    }
    ul {
      margin: 40px 10px;
      li {
        float: left;
        margin-right: 20px;
        text-align: center;
        border: 1px solid #25a7ea;
        width: 195px;
        padding: 32px 15px 0;
        height: 290px;
        h3 {
          color: #333;
          font-size: 16px;
          margin-top: 15px;

        }
        p {
          color: #666;
          font-size: 16px;
          margin-top: 15px;
          line-height: 1.5em;
        }
      }
      li:nth-of-type(4) {
        margin-right: 0 !important;
      }
    }
  }

  .fc_1 {
    .fc_con {
      height: 429px;
      margin: 3px;
      box-sizing: border-box;
      background: url("//v3.cdn.qiyewan.com/cs_tu.png") no-repeat;
      background-size: cover;
      text-align: center;
      color: #040000;
      letter-spacing: 2px;
      h5 {
        font-size: 24px;
        padding-top: 110px;
        font-weight: normal;
      }
      h3 {
        font-size: 30px;
        padding-top: 36px;
      }
      p {
        font-size: 16px;
        padding-top: 30px;
      }
    }
  }

  .fc_2 {
    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
    }
    ul {
      margin: 0 50px;
      display: flex;
    }
    li:nth-of-type(3) {
      padding-right: 0 !important;
    }
    ul li {
      float: left;
      margin-top: 30px;
      text-align: center;
      box-sizing: border-box;
      padding-right: 30px;
      p {
        font-size: 14px;
        color: #999;
        margin-top: 25px;
      }
      h3 {
        font-size: 18px;
        color: #666;
        text-align: center;
        margin-bottom: 5px;
        margin-top: 50px;
      }
    }
  }

  .fc_3 {
    background-color: #f6f6f7;
    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
      padding-top: 50px;
    }
    ul {
      margin: 0 130px;
      display: flex;
      justify-content: space-between;
      li:nth-of-type(1) {
        img {
          margin-top: 45px;
        }
      }
      li {
        text-align: center;
        img {
          margin-top: 50px;
        }

        p {
          font-size: 18px;
          color: #666;
          letter-spacing: 2px;
          margin-top: 20px;
          margin-bottom: 50px;
        }
      }
    }
  }

  .qf_2 {
    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
    }
    ul {
      margin: 0 50px;
      display: flex;
    }
    li:nth-of-type(3) {
      padding-right: 0 !important;
    }
    ul li {
      float: left;
      margin-top: 30px;
      text-align: center;
      box-sizing: border-box;
      padding-right: 30px;
      p {
        font-size: 16px;
        color: #999;
        margin-top: 25px;
      }
    }
  }

  .fc_4 {
    ul {
      display: flex;
      justify-content: space-between;
      margin: 3px;
    }
    li {
      border: 1px solid #eaeaea;
      width: 270px;
      margin: 30px 0 10px;
      img {
        width: 270px;
      }
      h4 {
        color: #0077db;
        font-size: 22px;
        margin-top: 25px;
        padding: 0 30px;
      }
      p {
        color: #666;
        font-size: 16px;
        padding: 15px 30px;
      }
    }
  }

  .it_1 {
    height: 422px;
    margin: 3px;
    box-sizing: border-box;
    background: url("//v3.cdn.qiyewan.com/IT_tu.png") no-repeat;
    background-size: cover;
    color: #888888;
    font-size: 16px;
    p {
      margin-left: 347px;
      padding-top: 232px;
      width: 301px;
      line-height: 1.8em;
    }
  }

  .it_2 {
    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
      margin-bottom: 20px;
    }
    .summary {
      text-align: center;
      color: #b0b0b0;
      font-size: 16px;
    }

    ul {
      margin: 0 130px;
      display: flex;
      justify-content: space-between;
      li {
        text-align: center;
        img {
          margin-top: 50px;
        }

        p {
          font-size: 18px;
          color: #666;
          letter-spacing: 2px;
          margin-top: 20px;
          margin-bottom: 50px;
        }
      }
    }
  }

  .it_3 {
    height: 142px;
    box-sizing: border-box;
    background: url("//v3.cdn.qiyewan.com/IT_tu2.png") no-repeat;
    background-size: cover;
    color: #fff;
    text-align: center;
    letter-spacing: 2px;
    h3 {
      font-size: 40px;
      padding-top: 29px;
      font-style: italic
    }
    h5 {
      font-size: 24px;
      margin-top: 8px;
      font-style: italic
    }
  }

  .it_4 {
    height: 142px;

    box-sizing: border-box;
    background: url("//v3.cdn.qiyewan.com/IT_tu3.png") no-repeat;
    background-size: cover;
    color: #fff;
    text-align: center;

    h3 {
      font-size: 40px;
      padding-top: 29px;
      font-style: italic
    }
    h5 {
      font-size: 24px;
      margin-top: 8px;
      font-style: italic;
      letter-spacing: 3px;
    }
  }

  .it_5 {
    li {
      float: left;
      width: 50%;
      height: 258px;
      .title {
        font-size: 26px;
        color: #040404;
        margin-top: 30px;
        margin-left: 40px;
        span {
          font-size: 15px;
          color: #0077db;
        }
        strong {
          font-size: 30px;
          font-weight: bold;;
        }
      }
      p {
        margin-left: 40px;
        font-size: 18px;
        width: 260px;
        margin-top: 20px;
        line-height: 1.8em;
      }
      h3 {
        margin-left: 40px;
        font-size: 22px;
        margin-top: 10px;

      }
    }
    img {
      width: 100%;

    }

  }

  .ld_1 {
    .ld_con {
      height: 567px;
      margin: 3px;
      box-sizing: border-box;
      background: url("//v3.cdn.qiyewan.com/fal_tu.png") no-repeat;
      background-size: cover;
      text-align: center;
      h5 {
        font-size: 36px;
        padding-top: 110px;
        color: #333;
        span {
          color: #0077db;
        }
      }
      h3 {
        font-size: 18px;
        width: 560px;
        height: 40px;
        line-height: 40px;
        margin: 25px auto 0;
        background-color: #0077db;
        color: #fff;
        border-radius: 40px;
      }
      p {
        font-size: 15px;
        padding-top: 30px;
        color: #999;
        width: 434px;
        line-height: 1.5em;
        margin: 0 auto;
      }
    }
  }

  .ld_2 {

    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
    }
    ul {
      background: url("//v3.cdn.qiyewan.com/ld_con2.png") no-repeat center;
      width: 100%;
      height: 676px;
    }
    ul li {
      p {
        font-size: 14px;
        color: #999;
        margin-top: 25px;
        line-height: 2em;
      }
      h3 {
        font-size: 18px;
        color: #333;
        margin-bottom: 5px;
        margin-top: 50px;
      }
    }
    li:nth-of-type(1) {
      margin-left: 471px;
      h3 {
        padding-top: 25px;
      }
    }
    li:nth-of-type(2) {
      margin-left: 130px;
      padding-top: 65px;
    }
    li:nth-of-type(3) {
      margin-left: 471px;
      padding-top: 65px;
    }
  }

  .ld_3 {
    background-color: #f6f6f7;
    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
      padding-top: 50px;
    }
    .aummary {
      text-align: center;
      font-size: 14px;
      color: #999;
      margin-top: 10px;
    }
    ul {
      margin: 0 70px;
      display: flex;
      justify-content: space-between;
      li:nth-of-type(1) {
        img {
          margin-top: 45px;
        }
      }
      li {
        text-align: center;
        img {
          margin-top: 50px;
        }

        p {
          font-size: 18px;
          color: #666;
          letter-spacing: 2px;
          margin-top: 20px;
          margin-bottom: 50px;
        }
      }
    }
  }

  .ld_4 {

    h2 {
      font-size: 25px;
      color: #333;
      text-align: center;
      margin-top: 50px;
    }
    ul {
      background: url("//v3.cdn.qiyewan.com/ld_con4.png") no-repeat center;
      width: 100%;
      height: 1430px;
    }
    ul li {
      width: 50%;
      p {
        font-size: 20px;
        margin-top: 25px;
        line-height: 1.8em;
        width: 281px;
        letter-spacing: 2px;
        padding: 30px;
      }
      h3 {
        font-size: 18px;
        color: #333;
        margin-bottom: 5px;
        margin-top: 50px;
        width: 289px;
        text-align: center;
      }
    }
    li:nth-of-type(1) {
      margin-left: 100px;
      h3 {
        padding-top: 25px;
      }
      p {
        padding: 70px 30px;
      }
    }
    li:nth-of-type(3) {
      margin-left: 100px;

      h3 {
        padding-top: 77px;
      }
      p {
        padding: 42px 30px;
      }
    }
    li:nth-of-type(2) {
      margin-left: 487px;
      padding-top: 65px;
      p {
        padding: 65px 30px;
      }
    }
    li:nth-of-type(4) {
      margin-left: 487px;
      padding-top: 50px;
      p {
        padding: 60px 30px;
      }
    }
  }

</style>

<template>
  <div>
    <div v-if="hasProductDetail">
      <div>
        <img :src="detailImgs[0]"
             alt="img"
             style="width: 100%;margin:3px;box-sizing: border-box"/>
      </div>

      <!--<img :src="`//v3.cdn.qiyewan.com/product-IT-1-pp.png`" alt="" style="width: 100%;margin:3px;box-sizing: border-box">-->
    </div>

    <div v-else>

      <!--ps-->
      <div v-if="product.classificationCode === 'PS' || product.classificationCode === 'IC'">
        <div class="ps_1">
          <div class="ps_con">
            <h3>高标准商标宝</h3>
            <h4>全方位助力企业发展</h4>
            <p>一站式超值服务</p>
          </div>
          <div class="ps_2">
            <h2>全面提升服务</h2>
            <ul>
              <li><img src="//v3.cdn.qiyewan.com/gsfw_1.png" alt="qsfw">
                <h3>快速</h3>
                <p>下单后即刻得到响应</p>
              </li>
              <li><img src="//v3.cdn.qiyewan.com/gsfw_2.png" alt="qsfw">
                <h3>安全</h3>
                <p>下单后即刻得到响应</p>
              </li>
              <li><img src="//v3.cdn.qiyewan.com/gsfw_3.png" alt="qsfw">
                <h3>专业</h3>
                <p>下单后即刻得到响应</p>
              </li>
              <li><img src="//v3.cdn.qiyewan.com/gsfw_4.png" alt="qsfw">
                <h3>无忧</h3>
                <p>下单后即刻得到响应</p>
              </li>
              <li><img src="//v3.cdn.qiyewan.com/gsfw_5.png" alt="qsfw">
                <h3>精准</h3>
                <p>下单后即刻得到响应</p>
              </li>
              <li><img src="//v3.cdn.qiyewan.com/gsfw_6.png" alt="qsfw">
                <h3>全面</h3>
                <p>下单后即刻得到响应</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!--FC-->
      <div v-if="product.classificationCode === 'FC'">
        <div class="fc_1">
          <div class="fc_con">
            <h5>企业湾为您解决全面财务问题</h5>
            <h3>专业代理记账服务、合理发展企业财务</h3>
            <p>保障信息安全 / 节约企业成本 / 专业服务 / 规避财务纠纷</p>
          </div>
        </div>
        <div class="fc_2">
          <h2>代理记账对企业的好处</h2>
          <ul>
            <li><img src="//v3.cdn.qiyewan.com/cshc_1.png" alt="">
              <h3>为您提供制度化服务</h3>
              <p>总账会计、成本会计、费用会计等，
                专业程度高，代理记账公司专业化</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/cshc_2.png" alt="">
              <h3>降低成本，节省费用</h3>
              <p>企业支付不到一个会计人员成本就可以
                享受一个专业会计团队的服务</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/cshc_3.png" alt="">
              <h3>多年财务经验，规避多重风险</h3>
              <p>多年的经营经验，经历过多种突发事件，
                可以说是经验丰富能够规避企业风险</p>
            </li>
          </ul>
        </div>
        <div class="fc_3">
          <h2>操作步骤</h2>
          <ul>
            <li><img src="//v3.cdn.qiyewan.com/cscz_1.png" alt="">
              <p>在线下单</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/cscz_2.png" alt="">
              <p>申请登记</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/cscz_3.png" alt="">
              <p>税种核定</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/cscz_4.png" alt="">
              <p>签订协议</p>
            </li>
          </ul>
        </div>

      </div>

      <!--QF-->
      <div v-if="product.classificationCode === 'QF'">
        <div class="qf_1">
          <img src="//v3.cdn.qiyewan.com/product-QF-1-pp.png" style="padding:3px;width: 100%;">
        </div>
        <div class="qf_2">
          <h2>企业具备的条件</h2>
          <ul>
            <li><img src="//v3.cdn.qiyewan.com/zztj_1.png" alt="">
              <p>符合国家规定，依照法定
                程序批准设立的机构</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/zztj_2.png" alt="">
              <p>有固定的工作场所和从事通信工程
                建设监理所需的设备</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/zztj_3.png" alt="">
              <p>实行独立核算，自负盈亏
                的独立法人实体</p>
            </li>
          </ul>
        </div>

      </div>

      <!--LD-->
      <div v-if="product.classificationCode === 'LD'">
        <div class="ld_1">
          <div class="ld_con">
            <h5><span>法律服务</span>是公司安全的重要基石</h5>
            <h3>线上下单，专业人员一对一办理，从始至终的客户第一的态度</h3>
            <p>Legal service is an important cornerstone of company safety
              ornerstone of company safety</p>
          </div>
        </div>
        <div class="ld_2">
          <h2>法律服务对公司的帮助</h2>
          <ul>
            <li>
              <h3>用法律制度保护权益</h3>
              <p>保护公司权益不受侵害 <br>
                当公司权益受到侵犯时可以拿起法律武器 <br>
                无论什么时候都要拿起法律的武器</p>
            </li>

            <li>
              <h3>高效精准节约时间成本</h3>
              <p>保护公司权益不受侵害 <br>
                当公司权益受到侵犯时可以拿起法律武器 <br>
                无论什么时候都要拿起法律的武器
              </p>
            </li>

            <li>
              <h3>制定合理制度让企业告诉发展</h3>
              <p>保护公司权益不受侵害 <br>
                当公司权益受到侵犯时可以拿起法律武器 <br>
                无论什么时候都要拿起法律的武器</p>
            </li>
          </ul>
        </div>

        <div class="ld_3">
          <h2>服务流程</h2>
          <div class="aummary">各地因为政策不同，所需办理的流程时间也不相同</div>
          <ul>
            <li><img src="//v3.cdn.qiyewan.com/falc_1.png" alt="">
              <p>售前咨询</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/falc_2.png" alt="">
              <p>在线下单</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/falc_3.png" alt="">
              <p>律师沟通</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/falc_4.png" alt="">
              <p>提供服务</p>
            </li>
            <li><img src="//v3.cdn.qiyewan.com/falc_5.png" alt="">
              <p>售后回访</p>
            </li>
          </ul>
        </div>
      </div>

      <!--IT-->
      <div v-if="product.classificationCode === 'IT'">

        <div class="it_1">
          <p>门户网站是公司最好的展现形式，在企业湾专人全程办理，足不出户帮您搞定</p>
        </div>
        <div class="it_2">
          <h2>服务流程</h2>
          <div class="summary">多数主管税务机关要求企业提供软件著作权和软件登记检测报告</div>
          <ul>
            <li><img src="//v3.cdn.qiyewan.com/itlc_1.png" alt="">
              <p>在线下单</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/itlc_2.png" alt="">
              <p>及时响应</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/itlc_3.png" alt="">
              <p>快速交付</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/itlc_4.png" alt="">
              <p>满意为止</p>
            </li>
          </ul>
        </div>
        <div class="it_3">
          <h3>企业湾</h3>
          <h5>一站超值快速响应</h5>
        </div>
      </div>

      <div class="clearfix" style="height: 30px;"></div>
      <div class="what-need-panel">
        <div class="what_tit">准备什么材料呢？</div>
        <ul class="what-need-list">
          <li v-for="(item,index) in whatNeed"><span>{{ index + 1 }} </span>
            <p>{{ item }}</p></li>
        </ul>
      </div>

      <!--ps-->
      <div v-if="product.classificationCode === 'PS' || product.classificationCode === 'IC'">
        <div class="ps_3">
          <h2>企业为什么要进行工商服务</h2>
          <ul>
            <li>
              <h3>服务公开</h3>
              <p>根据合同及服务须知严格操
                作，也可根据客户情况按标
                准注册时间和注册要求加急
                特殊通道办理。</p>
            </li>

            <li>
              <h3>价格透明</h3>
              <p>明码实价，签订协议后不再
                收取任何附加费用。</p>
            </li>

            <li>
              <h3>程序便捷</h3>
              <p>按照注销基本程序、企业完
                备材料依次进行，方便快捷
                ，节省时间。</p>
            </li>
          </ul>
        </div>
        <div class="ps_4">
          <h2>企业湾一站超值快速响应</h2>
          <ul>
            <li>
              <img src="//v3.cdn.qiyewan.com/gsxy_1.png" alt="">
              <h3>超值价格</h3>
              <p>服务价格公开透明，无
                任何隐形消费</p>
            </li>

            <li>
              <img src="//v3.cdn.qiyewan.com/gsxy_2.png" alt="">
              <h3>快速响应</h3>
              <p>在线下单4小时响应，对
                接流程专业、简约</p>
            </li>

            <li>
              <img src="//v3.cdn.qiyewan.com/gsxy_3.png" alt="">
              <h3>服务专业</h3>
              <p>专属顾问为您服务，资深
                专家为您把脉，企业湾专
                业自营团队为您企业保驾
                护航</p>
            </li>

            <li>
              <img src="//v3.cdn.qiyewan.com/gsxy_4.png" alt="">
              <h3>一站式服务</h3>
              <p>工商、财税、法务、人事
                、IT全覆盖，为您创业全
                方位助力</p>
            </li>
          </ul>
        </div>
      </div>

      <!--fc-->
      <div v-if="product.classificationCode === 'FC'">
        <div class="fc_4">

          <img src="//v3.cdn.qiyewan.com/product-FC-4-pp.png" style="padding:3px;width: 100%;"/>
        </div>
      </div>

      <!--qf-->
      <div v-if="product.classificationCode === 'QF'">
        <div class="fc_3">

          <img src="//v3.cdn.qiyewan.com/product-QF-3-pp.png" style="padding:3px;width: 100%;"/>
        </div>
        <div class="fc_4">
          <ul>
            <li><img src="//v3.cdn.qiyewan.com/zzfw_1.png" alt="">
              <h4>专业的服务</h4>
              <p>几十位资质服务相关的专家为您
                提供专业的解答</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/zzfw_2.png" alt="">
              <h4>快速的响应</h4>
              <p>在线下单4小时内，服务人员快
                速对接，积极响应</p>
            </li>

            <li><img src="//v3.cdn.qiyewan.com/zzfw_3.png" alt="">
              <h4>高效的流程</h4>
              <p>一旦服务生成，流程迅速展开，
                便捷、简约</p>
            </li>
          </ul>
        </div>
      </div>

      <!--IT-->
      <div v-if="product.classificationCode === 'IT'">
        <div class="it_4">
          <h3>信赖企业湾</h3>
          <h5>助您圆梦企业成功</h5>
        </div>
        <div class="it_5">
          <ul>
            <li>
              <div class="title">
                优势 <strong>1</strong> <br><span>A bargain price</span>

              </div>
              <h3>超值价格</h3>
              <p>服务价格公开透明，无任何隐形消费</p>
            </li>

            <li>
              <img src="//v3.cdn.qiyewan.com/itys_1.png" alt="">
            </li>

            <li>
              <img src="//v3.cdn.qiyewan.com/itys_2.png" alt="">
            </li>

            <li>
              <div class="title">
                优势 <strong>2</strong> <br><span>A quick response</span>

              </div>
              <h3>快速响应</h3>
              <p>在线下单4小时响应，对接流程专业、简约</p>
            </li>

            <li>
              <div class="title">
                优势 <strong>3</strong> <br><span>Professional service</span>

              </div>
              <h3>服务专业</h3>
              <p>专属顾问为您服务，资深专家为您把脉，企业湾专业自营团队为您企业保驾护航</p>
            </li>

            <li>
              <img src="//v3.cdn.qiyewan.com/itys_3.png" alt="">
            </li>
            <li>
              <img src="//v3.cdn.qiyewan.com/itys_4.png" alt="">
            </li>

            <li>
              <div class="title">
                优势 <strong>4</strong> <br><span>One-stop service</span>

              </div>
              <h3>一站式服务</h3>
              <p>工商、财税、法务、人事、IT全覆盖，为您创业全方位助力</p>
            </li>
          </ul>
        </div>
      </div>

      <!--LD-->
      <div v-if="product.classificationCode === 'LD'">
        <div class="ld_4">
          <h2>企业湾服务优势</h2>
          <ul>
            <li>
              <h3>1.超值价格</h3>
              <p>服务价格公开透明，无任何隐形消费</p>
            </li>

            <li>
              <h3>2.快速响应</h3>
              <p>在线下单4小时响应，对接流程专业、简约
              </p>
            </li>

            <li>
              <h3>3.服务专业</h3>
              <p>专属顾问为您服务，资深专家为您把脉，企业湾专业自营团队为您企业保驾护航</p>
            </li>

            <li>
              <h3>4.一站式服务</h3>
              <p>工商、财税、法务、人事、IT全覆盖，为您创业全方位助力</p>
            </li>

          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    props: {
      product: Object,
      whatNeed: Array,
    },
    computed: {
      hasProductDetail() {
        let classificationCode = this.product.classificationCode
        let classificationName = this.product.classificationName
        return ['IT'].includes(classificationCode) && ['设计', '公众号运营'].includes(classificationName)

      },
      detailImgs() {
        let code = this.product.classificationCode
        let serialId = this.product.serialId.substr(4)
          return [
            `//v3.cdn.qiyewan.com/product-${serialId}.jpg`
          ]
        }

    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// ServiceDetail.vue?79377a72